module.exports = __webpack_public_path__ + "img/DigitalSHMSystem_Login_top.a403a919.svg";